import uuidv4 from 'uuid/v4';

const generateRandomId = () => {
  const id = uuidv4()
    .split('-')
    .join('');
  return id;
};

export default generateRandomId;
